import { hexToRGBA } from '@stack/helpers';

import { Mode, Skin } from '../../@types';

import { OwnerStateThemeType } from '.';

/**
 * ===========================
 * MAIN
 * ===========================
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createThemeOverrideBackdrop = (mode: Mode, skin: Skin) => {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor:
            theme.palette.mode === 'light'
              ? `rgba(${theme.palette.customColors.main}, 0.5)`
              : hexToRGBA('#101121', 0.87),
        }),
        invisible: {
          backgroundColor: 'transparent',
        },
      },
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideBackdrop;
